var map = {
	"./AMERON_Davos.jpg": 87,
	"./Alpina_Gstaad.jpg": 88,
	"./Badrutt_St_Moritz.jpg": 89,
	"./Belvedere_Scuol.jpg": 90,
	"./Bernerhof_Kandersteg.jpg": 91,
	"./Carlton_St_Moritz.jpg": 92,
	"./Chedi_Andermatt.jpg": 93,
	"./Chesa_Randolina_Sils.jpg": 94,
	"./Grand_Bellevue_Gstaad.jpg": 95,
	"./Kernen_Schoenried_Gstaad.jpg": 96,
	"./Krone_La_Punt.jpg": 97,
	"./Kulm_St_Moritz.jpg": 98,
	"./Palace_Gstaad.jpg": 99,
	"./Radisson_Andermatt.jpg": 100,
	"./Riffelalp_Zermatt.jpg": 101,
	"./Rockresort_Laax.jpg": 102,
	"./Schoenegg_Wengen.jpg": 103,
	"./Schweizerhof_Lenzerheide.jpg": 104,
	"./Spitzhorn_Saanen.jpg": 105,
	"./Sporthotel_Pontresina.jpg": 106,
	"./Suvretta_St_Moritz.jpg": 107,
	"./Tschuggen_Arosa.jpg": 108,
	"./Unique_Zermatt.jpg": 109,
	"./Valsana_Arosa.jpg": 110,
	"./Waldhaus_st_Moritz.jpg": 111,
	"./Zurbriggen_Saas.jpg": 112,
	"./backstage_vernissage_Zermatt.jpg": 113,
	"./chasa_montana_Samnaun.jpg": 114,
	"./guardaval_Lenzerheid.jpg": 115,
	"./jungfrau-wengernalp.jpg": 116
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(function(id) {
		return __webpack_require__.t(id, 7);;
	});
}
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e(/* lazy-once context | placeholder */ 31).then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 84;
module.exports = webpackAsyncContext;